import { EXPRESS_API } from 'configs/api/expressApi';
import { SMSAttachment } from './types';
import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { useHistory } from 'react-router';
import { conversationsKeys } from '../conversations/queryKeys';
import { messagesKeys } from '../messages/messagesKeys';
import { IMessage } from '../messages/types';
import { useToastError } from 'lib/hooks';

interface ISendSmsData {
  text: string;
  phone: string;
  attachments?: SMSAttachment[];
  usePodium?: boolean;
}
export const sendSms = async (data: ISendSmsData) => {
  const { phone, text, attachments, usePodium } = data;
  const body = {
    to: phone,
    text,
    attachments: attachments || [],
    usePodium,
  };
  const response = await EXPRESS_API.post(`/sms/send`, body);

  return response.data;
};

interface ISendSmsProps {
  id: string;
  range: string;
}

export const useSendSms = ({ id, range }: ISendSmsProps) => {
  const queryClient = useQueryClient();
  const history = useHistory();
  const { showError } = useToastError();
  return useMutation(sendSms, {
    onSuccess: (res: IMessage) => {
      successToast({ title: 'Your message is sent successfully!' });

      if (id === 'new') {
        history.replace({
          pathname: `/sms/chats/${res.chatId}`,
          search: `?range=${range}`,
        });
      }

      queryClient.invalidateQueries(
        conversationsKeys.single_chat(`${res.chatId}`),
        {
          active: true,
        }
      );
      queryClient.invalidateQueries(messagesKeys.all());
    },
    onError: err => {
      showError(err);
    },
  });
};
